const LoginActions = () => {
  return (
    <div className="flex items-center justify-between text-sm mb-6">
      <label className="flex items-center gap-2">
        <input type="checkbox" />
        Remember me
      </label>

      <button type="button" className="text-gray-600 hover:text-black">
        Forgot password?
      </button>
    </div>
  );
};

export default LoginActions;
